import { render, staticRenderFns } from "./workOrderSection.vue?vue&type=template&id=6cb54057&scoped=true"
import script from "./workOrderSection.vue?vue&type=script&lang=js"
export * from "./workOrderSection.vue?vue&type=script&lang=js"
import style0 from "./workOrderSection.vue?vue&type=style&index=0&id=6cb54057&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb54057",
  null
  
)

export default component.exports